import { NumVisitors } from '@/config/enums';
import { ReadonlyURLSearchParams } from 'next/navigation';

export const getNumVisitors = (searchParams: ReadonlyURLSearchParams) => {
  const sizeStart = Number(searchParams.get('groupSizeStart')) || 0;
  const sizeEnd = Number(searchParams.get('groupSizeEnd')) || 0;

  if (sizeEnd === 1) return NumVisitors.PRIVATE_TOUR;
  if (sizeEnd === 10) return NumVisitors.UP_TO_TEN;
  if (sizeEnd === 20) return NumVisitors.UP_TO_TWENTY;
  if (sizeEnd === 50) return NumVisitors.UP_TO_FIFTY;
  if (!sizeEnd && sizeStart === 50) return NumVisitors.FIFTY_PLUS;
  return 0;
};
